export { default } from './AppScrollToTop'
